export default __webpack_public_path__ + "static/media/256591.704ad173.gif";